module.exports = __webpack_public_path__ + "img/logos-bar4.5d3db5d2.jpg";